import axios from "../../utils/axios";

export const getBlogs = async (filter, sort) => {
  console.log(filter, sort);
  if (!filter && !sort) {
    const responce = await axios.get("/blogs");
    return responce.data;
  }
  if (filter && !sort) {
    const responce = await axios.get(`/blogs?isSaved=true&_order=desc`);
    return responce.data;
  }
  if (sort && !filter) {
    const responce = await axios.get(`blogs?&_sort=${sort}&_order=desc`);
    return responce.data;
  }
  if (sort && filter) {
    const responce = await axios.get(`/blogs?isSaved=${filter}&_sort=${sort}&_order=desc`);
    return responce.data;
  }
};
